module.exports = __webpack_public_path__ + "img/economicsOrange.e1424b4a.png";